import React from 'react';

import { ReCaptcha } from '@core/js/components/main/ReCaptcha';

import { useTranslations } from '@core/js/hooks/i18n';
import cls from '@core/js/utils/classNameBuilder.util';

import { TReCaptchaWithTitleProps } from './types';

import style from './ReCaptchaWithTitle.scss';

export const ReCaptchaWithTitle: React.FC<TReCaptchaWithTitleProps> = ({ titleTKey = '', classNames = {}, ...reCaptchaProps }) => {
    const translate = useTranslations('playtech.mobile.system.ReCaptcha.title.');
    const tValue = translate(titleTKey);

    return (
        <div className={cls(['wrapper'], style, classNames)}>
            {titleTKey && Boolean(tValue) && (
                <span className={style.title}>
                    {tValue}
                </span>
            )}

            <ReCaptcha {...reCaptchaProps} />
        </div>
    );
};
